export enum PrivilegeType {
  WRITE = 'WRITE',
  READ = 'READ',
}

export enum PrivilegeTypeEnum {
  READ = 'READ',
  READWRITE = 'READWRITE',
  NOACCESS = 'NOACCESS',
  MIXED = 'MIXED',
  WRITEDENY = 'WRITEDENY',
}

export enum BasicPrivilegeTypeEnum {
  READ = PrivilegeTypeEnum.READ,
  READWRITE = PrivilegeTypeEnum.READWRITE,
}

export enum SharePermissionEnum {
  READONLY = 'READONLY',
  FULL = 'FULL',
  REMOVE = 'REMOVE',
}

// Used by the filebrowser but the name propagtes to the backend
export enum BaseSteps {
  VisibleToAll = 'VisibleToAll',
  DataRoom = 'DataRoom',
  MeetingFiles = 'MeetingFiles',
  PersonalFiles = 'PersonalFiles',
  _SHARED_WITH_ME_ = '_SHARED_WITH_ME_',
  _SHARED_I_CONTROL_ = '_SHARED_I_CONTROL_',
}
export function isFakeShared(folderName: string): boolean {
  return folderName === BaseSteps._SHARED_WITH_ME_ || folderName === BaseSteps._SHARED_I_CONTROL_;
}
export interface ACLPrivileges {
  READ?: boolean;
  WRITE?: boolean;
}

export function aclPrivesToString(acl): string {
  let ret = '';
  if (acl.READ) {
    ret += 'R';
  }
  if (acl.WRITE) {
    ret += 'W';
  }
  return ret;
}
export interface ACLMap {
  [group: string]: ACLPrivileges;
}

export enum DirentNameEnum {
  VINILLA = 'VINILLA',
  USER_ID = 'USER_ID',
  MEETING_ID = 'MEETING_ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  KEY = 'KEY',
  KEY_MUTABLE = 'KEY_MUTABLE',
}

// export enum DirentNameEnum {
//   VINILLA = 'VINILLA',
//   USER_ID = 'USER_ID',
//   MEETING_ID = 'MEETING_ID',
//   ORGANIZATION_ID = 'ORGANIZATION_ID',
//   KEY = 'KEY',
//   KEY_MUTABLE = 'KEY_MUTABLE',
// }

export type DirentPermissionMap = { [group: string]: BasicPrivilegeTypeEnum };

export function aclPrivsToPrivilegeType(x: ACLPrivileges): BasicPrivilegeTypeEnum {
  if (x.READ && x.WRITE) return BasicPrivilegeTypeEnum.READWRITE;
  if (x.READ) return BasicPrivilegeTypeEnum.READ;
  else return null;
}

export function acl2PermissionMap({ acl }: { acl: ACLMap }): DirentPermissionMap {
  const permissionMap: DirentPermissionMap = {};
  for (const group of Object.keys(acl)) {
    const groupACL = acl[group];
    const priv: BasicPrivilegeTypeEnum = aclPrivsToPrivilegeType(groupACL);
    permissionMap[group] = priv;
  }
  return permissionMap;
}

export function permissionMap2Acl({
  permissionMap,
}: {
  permissionMap: DirentPermissionMap;
}): ACLMap {
  const acl: ACLMap = {};

  for (const group of Object.keys(permissionMap || {})) {
    switch (permissionMap[group]) {
      case BasicPrivilegeTypeEnum.READ:
        acl[group] = { READ: true };
        break;

      case BasicPrivilegeTypeEnum.READWRITE:
        acl[group] = { READ: true, WRITE: true };
        break;
      default:
        console.log('permissionMap2Acl: Unknown permission type');
    }
  }
  return acl;
}
